import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=ab4b3ff2&scoped=true&lang=pug&"
import script from "./NoticeMessage.vue?vue&type=script&lang=ts&"
export * from "./NoticeMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b3ff2",
  null
  
)

export default component.exports